"use strict";
exports.__esModule = true;
exports.DEFAULT_PICK_UP_TIME = exports.DEFAULT_CUT_OFF_TIME = void 0;
exports.DEFAULT_CUT_OFF_TIME = "12:00 PM";
exports.DEFAULT_PICK_UP_TIME = "03:00 PM";
